import { dropdownMapping, fetchAllPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../../manage/common/constant"
import { masterServiceBaseUrl } from "services/http";


export const FILTER__FORM_FIELDS_GLOBAL = {
    country: [],
    state: [],
    pincode: "",
    board: [],
    type: [],
    status: [],
    mappedBranchIds: [],
    searchValue: '',
};

export const hardcodeDropdown = {
    schoolType: [
  { label: 'GOVT - Government', value: 'GOVT' },
  { label: 'PRIV - Private', value: 'PRIV' },
  { label: 'PUBL - Public', value: 'PUBL' },
  { label: 'STBD - State Board', value: 'STBD' },
  { label: 'DEFN - Military/Defense', value: 'DEFN' }
],
    schoolStatus: [
        {
            id: 1,
            label: "Active",
            value: "Active",
        },
        {
            id: 2,
            label: "Inactive",
            value: "Inactive",
        }
    ],
};


export const statusStyle = {
    active: {
        backgroundColor: "#BBE2CE",
        color: "#0B442D",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    },
    inactive: {
        backgroundColor: "#F5F5F5",
        color: "#262626",
        padding: "4px 11px",
        fontSize: "12px",
        borderRadius: "8px",
    }

}

export const labelStyles = {
    fontSize: "12px",
    marginTop: "4px",
};

export const ignoreFilterItem = ["schoolType", "searchValue"];

export const getDropdowns = async () => {
    try {
        const p = await Promise.all([
            dropdownMapping(`${masterServiceBaseUrl}/country/getAllCountry`, 'countryDispValue', 'id'),
            // dropdownMapping(endpoint?.region?.getAllActive, 'regionDispValue', 'id'),
            dropdownMapping(endpoint?.state?.getAll, 'stateDispValue', 'id'),
            dropdownMapping(endpoint.examBoardType.getAllActive, "examBoardTypeDispValue", 'id'),
            dropdownMapping(endpoint.businessArea.getAllActive, 'businessAreaDispValue', 'id'),
            dropdownMapping(endpoint?.city?.getAll, 'cityDispValue', 'id'),
        ]);

        return {
            allcountry: p[0],
            // allRegion: p[1],
            allState: p[1],
            board: p[2],
            allBusinessArea: p[3],
            city: p[4]
        }
    } catch (err) {
        console.log(err);
    }
}
export const validatePincode = async (setGlobalFilter, pincode) => {
    console.log("type of pincode ", typeof (pincode));
    try {
        if (!pincode) return;
        const res = await fetchAllPromisedData(`${endpoint?.pincode?.getPinCodeDetails}/${pincode}`);
        let validPincode = '';
        if (res) {
            validPincode = pincode;
        }
        console.log("valid pincode ----", validPincode)
        setGlobalFilter(prev => ({
            ...prev,
            pincode: validPincode
        }))
    } catch (err) {
        console.log(err);
    }
};

export const hardcodeResponse = [
    {
        "id": 1,
        "schoolId": "12",
        "name": "st-xavier",
        "description": "senior sec school",
        "board": "CBSE",
        "type": "private",
        "region": "DELHI",
        "state": "DELHI ",
        "city": "DELHI",
        "pincode": "110007",
        "branch": "JP001",
        "effectiveDate": "2025-02-19T11:47:23.000+00:00",
        "lastUpdateOn": "2025-02-19T11:47:23.000+00:00",
        "status": "Active"
    },
    {
        "id": 2,
        "schoolId": "12",
        "name": "st-xavier",
        "description": "senior sec school",
        "board": "CBSE",
        "type": "private",
        "region": "DELHI",
        "state": "DELHI ",
        "city": "DELHI",
        "pincode": "110007",
        "branch": "JP001",
        "effectiveDate": "2025-02-19T11:47:23.000+00:00",
        "lastUpdateOn": "2025-02-19T11:47:23.000+00:00",
        "status": "InActive"
    },
    {
        "id": 3,
        "schoolId": "12",
        "name": "st-xavier",
        "description": "senior sec school",
        "board": "CBSE",
        "type": "private",
        "region": "DELHI",
        "state": "DELHI ",
        "city": "DELHI",
        "pincode": "110007",
        "branch": "JP001",
        "effectiveDate": "2025-02-19T11:47:23.000+00:00",
        "lastUpdateOn": "2025-02-19T11:47:23.000+00:00",
        "status": "Active"
    },

]

const getDisplayValueById = (dropdown = [], id) => {
    return (dropdown.find(item => item?.value == id))?.label
}

export const getDisplayList = (dropdowns = {}, rows = []) => {
    return rows.map(item => ({
        ...item,
        board: getDisplayValueById(dropdowns?.board, item?.board),
        city: getDisplayValueById(dropdowns?.city, item?.city),
        state: getDisplayValueById(dropdowns?.allState, item?.state),
        // region: getDisplayValueById(dropdowns?.allRegion,item?.region),
        branch: [...new Set(item?.branches.map(e => (
            getDisplayValueById(dropdowns?.allBusinessArea, e?.bu)
        )))]
    }))
}


